import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, errorText } from "@/lib/api";
import { Panel } from "@/components/admin/shared";
import { SeasonEditor } from "@/components/admin/decor/SeasonEditor";

export const DecorationsTab = () => {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/admin/decorations").then((r) => setData(r.data)).catch((e) => toast.error(errorText(e))), []);
  useEffect(() => { load(); }, [load]);
  if (!data) return <Loader2 className="animate-spin text-brand" />;
  const overlap = async (v) => { try { await api.put("/admin/decorations-settings", { allow_overlap: v }); toast.success("Guardado"); } catch (e) { toast.error(errorText(e)); } load(); };
  return (
    <div className="space-y-6" data-testid="decorations-admin">
      <Panel title="Decoraciones y eventos especiales">
        <p className="text-sm text-mute">Para que una temporada se vea, debe estar <b>activada</b> y dentro de sus fechas (hora de Mérida, ahora {data.now}). Al terminar el periodo deja de mostrarse sola, aunque no abras el panel. Los adornos nunca bloquean botones ni formularios.</p>
        <label className="mt-4 flex items-center gap-3 text-sm"><Switch checked={data.allow_overlap} onCheckedChange={overlap} data-testid="decor-overlap-switch" /> Mostrar varias temporadas a la vez si sus fechas coinciden (si no, se muestra solo la de mayor prioridad)</label>
      </Panel>
      {data.seasons.map((s) => <SeasonEditor key={s.id + s.updated_at} season={s} onChange={load} />)}
    </div>
  );
};
